import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const DESTINATIONS = [
  {
    country: "France",
    note: "Schengen short-stay",
    img: "https://images.pexels.com/photos/14995903/pexels-photo-14995903.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-7",
    height: "h-[300px] md:h-[440px]",
  },
  {
    country: "Italy",
    note: "Tourism & family visits",
    img: "https://images.pexels.com/photos/29322786/pexels-photo-29322786.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-5",
    height: "h-[300px] md:h-[440px]",
  },
  {
    country: "Greece",
    note: "Island itineraries",
    img: "https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?q=80&w=1000&auto=format&fit=crop",
    span: "md:col-span-4",
    height: "h-[280px] md:h-[360px]",
  },
  {
    country: "Spain",
    note: "Business & leisure",
    img: "https://images.unsplash.com/photo-1583422409516-2895a77efded?q=80&w=1000&auto=format&fit=crop",
    span: "md:col-span-4",
    height: "h-[280px] md:h-[360px]",
  },
  {
    country: "Czechia",
    note: "Study & work permits",
    img: "https://images.unsplash.com/photo-1541849546-216549ae216d?q=80&w=1000&auto=format&fit=crop",
    span: "md:col-span-4",
    height: "h-[280px] md:h-[360px]",
  },
  {
    country: "Netherlands",
    note: "Conference travel",
    img: "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?q=80&w=1000&auto=format&fit=crop",
    span: "md:col-span-6",
    height: "h-[280px] md:h-[380px]",
  },
  {
    country: "Italy — Veneto",
    note: "Multi-entry files",
    img: "https://images.unsplash.com/photo-1523906921802-b5d2d899e93b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHx2ZW5pY2UlMjBjYW5hbHMlMjBkYXl8ZW58MHx8fHwxNzg3NzQ2NzcyfDA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-6",
    height: "h-[280px] md:h-[380px]",
  },
];

export const Destinations = () => (
  <section data-testid="destinations-section" className="px-6 md:px-12 py-28 md:py-36">
    <div className="max-w-[1400px] mx-auto">
      <div className="flex flex-wrap items-end justify-between gap-8 mb-16">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: EASE }}
            className="text-xs font-semibold tracking-[0.25em] uppercase text-slate-500 mb-5"
          >
            Destinations
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
            className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900"
          >
            Where we file, most.
          </motion.h2>
        </div>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.2, ease: EASE }}
          className="max-w-sm text-sm text-slate-600 leading-relaxed"
        >
          Every consulate has its own forms, quirks and unwritten rules. We
          keep current with all of them, so your application lands right the
          first time.
        </motion.p>
      </div>

      <div className="grid md:grid-cols-12 gap-6">
        {DESTINATIONS.map((d, i) => (
          <motion.figure
            key={d.country + i}
            data-testid={`destination-${d.country.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            initial={{ opacity: 0, y: 48 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: (i % 3) * 0.12, ease: EASE }}
            className={`group relative overflow-hidden ${d.span} ${d.height}`}
          >
            <img
              src={d.img}
              alt={d.country}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent" />
            <figcaption className="absolute bottom-0 left-0 p-6">
              <p className="font-display text-xl sm:text-2xl text-white">{d.country}</p>
              <p className="text-xs tracking-[0.2em] uppercase text-white/70 mt-1.5">{d.note}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
